// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8564":"css/app.7052","8903":"css/admin-app.7052"}[chunkId] + ".css";
};